const PROGRAMS_NAMES = [
  {
    value: '27',
    label: 'AAR Input',
  },
  {
    value: '43',
    label: 'Aircraft Statuses',
  },
  {
    value: '102',
    label: 'AUXCOMM',
  },
  {
    value: '18',
    label: 'Battle Rhythm',
  },
  {
    value: '13',
    label: 'Bookmarks',
  },
  {
    value: '90',
    label: 'Call Centers',
  },
  {
    value: '6',
    label: 'Chat',
  },
  {
    value: '82',
    label: 'Checklists',
  },
  {
    value: '24',
    label: 'Communication Checks',
  },
  {
    value: '22',
    label: 'County Closures',
  },
  {
    value: '96',
    label: 'County Feeding',
  },
  {
    value: '23',
    label: 'County Indicators',
  },
  {
    value: '37',
    label: 'County Resource Lists',
  },
  {
    value: '85',
    label: 'CRASS',
  },
  {
    value: '52',
    label: 'Damage Assessments',
  },
  {
    value: '38',
    label: 'Debris Sites',
  },
  {
    value: '36',
    label: 'Disaster Recovery Centers',
  },
  {
    value: '94',
    label: 'Distribution Lists',
  },
  {
    value: '34',
    label: 'Donations',
  },
  {
    value: '45',
    label: 'DOT Video Wall',
  },
  {
    value: '86',
    label: 'Drinking Water/Wastewater',
  },
  {
    value: '9',
    label: 'Event Journal',
  },
  {
    value: '17',
    label: 'Executive Summaries',
  },
  {
    value: '30',
    label: 'Field Reports',
  },
  {
    value: '15',
    label: 'File Library',
  },
  {
    value: '104',
    label: 'Financial Institutions',
  },
  {
    value: '42',
    label: 'FPCON',
  },
  {
    value: '108',
    label: 'Gameday',
  },
  {
    value: '44',
    label: 'Hospitals',
  },
  {
    value: '16',
    label: 'Import Shapefile',
  },
  {
    value: '51',
    label: 'Incident Journal',
  },
  {
    value: '7',
    label: 'Incidents',
  },
  {
    value: '33',
    label: 'Inventory',
  },
  {
    value: '91',
    label: 'Lifelines',
  },
  {
    value: '77',
    label: 'Local Facilities',
  },
  {
    value: '101',
    label: 'Local Response',
  },
  {
    value: '76',
    label: 'Location Services',
  },
  {
    value: '35',
    label: 'Mass Feeding',
  },
  {
    value: '98',
    label: 'MCM Points of Dispensing',
  },
  {
    value: '10',
    label: 'Missions',
  },
  {
    value: '75',
    label: 'MSEL',
  },
  {
    value: '39',
    label: 'Mutual Aid Channels',
  },
  {
    value: '4',
    label: 'Notifications',
  },
  {
    value: '21',
    label: 'Operational Rhythm',
  },
  {
    value: '50',
    label: 'Points of Interest',
  },
  {
    value: '8',
    label: 'Position Logs',
  },
  {
    value: '26',
    label: 'Power Providers',
  },
  {
    value: '14',
    label: 'Print Map',
  },
  {
    value: '25',
    label: 'Public Information',
  },
  { value: '3', label: 'Resource Request' },
  {
    value: '81',
    label: 'SCHP',
  },
  { value: '2', label: 'Shelters' },
  {
    value: '1',
    label: 'Significant Events',
  },
  {
    value: '95',
    label: 'Situation Report',
  },
  {
    value: '49',
    label: 'Spot Reports',
  },
  {
    value: '28',
    label: 'Staging Areas',
  },
  {
    value: '93',
    label: 'Surveys',
  },
  {
    value: '84',
    label: 'Tasks',
  },
  {
    value: '29',
    label: 'Traffic Control Points',
  },
  {
    value: '5',
    label: 'Units',
  },
  {
    value: '100',
    label: 'Virtual EOC',
  },
  {
    value: '31',
    label: 'Volunteers',
  },
  {
    value: '106',
    label: 'Warehouse',
  },
  {
    value: '107',
    label: 'Work Order',
  },
  {
    value: '32',
    label: 'Point Of Distribution',
  },
];

export default PROGRAMS_NAMES;
